import { TextField, makeStyles } from '@material-ui/core';
import { ACTIVITY_TITLE_MAX_LENGTH } from './activityCreationReducer';
import type { ActivityBoardCardPrefill } from './activityCreationReducer';

const useStyles = makeStyles(theme => ({
  field: {
    marginBottom: theme.spacing(2),
  },
}));

export interface ActivityContentFieldsProps {
  title: string;
  description: string;
  descriptionVisible: boolean;
  importedContext: string;
  card: ActivityBoardCardPrefill | null;
  titleError?: string;
  onTitleChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
}

const DescriptionField = ({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) => {
  const classes = useStyles();
  return (
    <TextField
      id="create-activity-description"
      label="Descrição"
      variant="outlined"
      size="small"
      fullWidth
      multiline
      minRows={4}
      className={classes.field}
      value={value}
      onChange={event => onChange(event.target.value)}
      InputLabelProps={{ shrink: true }}
      helperText="Conteúdo manual editável; não é apagado ao trocar o card."
    />
  );
};

const ImportedContextField = ({
  value,
  card,
}: {
  value: string;
  card: ActivityBoardCardPrefill;
}) => {
  const classes = useStyles();
  return (
    <TextField
      id="create-activity-imported-context"
      label={`Contexto importado do card (${card.provider} #${card.externalId})`}
      variant="outlined"
      size="small"
      fullWidth
      multiline
      minRows={4}
      className={classes.field}
      value={value}
      InputProps={{ readOnly: true }}
      InputLabelProps={{ shrink: true }}
      helperText="Somente leitura; trocar ou remover o card atualiza apenas este contexto."
    />
  );
};

export const ActivityContentFields = ({
  title,
  description,
  descriptionVisible,
  importedContext,
  card,
  titleError,
  onTitleChange,
  onDescriptionChange,
}: ActivityContentFieldsProps) => {
  const classes = useStyles();
  return (
    <>
      <TextField
        id="create-activity-title"
        label="Título"
        variant="outlined"
        size="small"
        fullWidth
        className={classes.field}
        value={title}
        onChange={event => onTitleChange(event.target.value)}
        error={Boolean(titleError)}
        helperText={
          titleError ||
          `${title.length}/${ACTIVITY_TITLE_MAX_LENGTH} caracteres`
        }
        inputProps={{ maxLength: ACTIVITY_TITLE_MAX_LENGTH }}
        InputLabelProps={{ shrink: true }}
      />
      {descriptionVisible && (
        <DescriptionField value={description} onChange={onDescriptionChange} />
      )}
      {importedContext && card && (
        <ImportedContextField value={importedContext} card={card} />
      )}
    </>
  );
};
